import type { Module } from '../types/modules'

export const inspModules = 'insp.modules'
export const inspModule = (type: Module['tag']) => `insp.module.${type}`
export const inspProductCard = 'insp.ProductCard'
export const inspProductCardIdx = (idx: number) => `insp.ProductCard.${idx}`
export const HERO_SECTION = 'inspirational.hero.section'
